<footer class="sticky-footer">
  <div class="container">
     <div class="row no-gutters">
        <div class="col-lg-6 col-sm-6">
           <p class="mt-1 mb-0">&copy; <span i18n="@@Copyright with Year | eg Copyright 2019">Copyright 2019</span> <strong class="text-light">VideYo</strong>. <span i18n="@@All rights reserved | All Rights Reserved Footer Text">All Rights Reserved</span><br>
             
           </p>
        </div>
        <div class="col-lg-6 col-sm-6 text-right">
           <!--<div class="app">
              <a routerLink="#"><img alt="" src="img/google.png"></a>
              <a routerLink="#"><img alt="" src="img/apple.png"></a>
          
           </div>
            -->
        </div>
     </div>
  </div>
</footer>
<!-- /#wrapper -->
<!-- Scroll to Top Button-->
<a class="scroll-to-top rounded" routerLink="#page-top">
<i class="fas fa-angle-up"></i>
</a>
